import { requiredNullish } from '@breezeventures/web-ph-validators/zod-utils';
import { z } from 'zod';

import { documentSchema } from './document-schema';

export const businessDocumentsSchema = z.object({
  BUSINESS_PERMIT: requiredNullish(
    documentSchema,
    'Business Permit is required'
  ),
  BIR_CERTIFICATE_OR_FORM2303: requiredNullish(
    documentSchema,
    'BIR Certificate or Form 2303 is required'
  ),
  DTI_CERTIFICATE: requiredNullish(
    documentSchema,
    'DTI Certificate is required'
  ),
  OTHER: z.array(documentSchema),
});

export type BusinessDocumentsFormValues = z.infer<
  typeof businessDocumentsSchema
>;
